module.exports = "<!-- ko component: {name: \"app\", params: $component.app  } --><!-- /ko -->\r\n\r\n<!-- ko foreach: $component.app.popupsManager.popups -->\r\n    <!-- ko component: {name: $data.component, params: $data } --><!-- /ko -->\r\n<!-- /ko -->"


//////////////////
// WEBPACK FOOTER
// ./ClientApp/components/shell/shell.html
// module id = 152
// module chunks = 53